// Colours, read from the CSS tokens (styles/tokens.css) so canvas and SVG match the page.
// GPL-3.0-or-later.
const cache = new Map<string, string>();
export function css(name: string) {
  let v = cache.get(name);
  if (v === undefined) { v = getComputedStyle(document.documentElement).getPropertyValue(name).trim(); cache.set(name, v); }
  return v;
}
/** The density ramp, sand to rust (7 bands). */
export const ramp = (): string[] => [1, 2, 3, 4, 5, 6, 7].map((i) => css(`--d${i}`));
export function hexToRgb(h: string): [number, number, number] {
  const m = h.replace("#", "");
  const n = parseInt(m.length === 3 ? m.split("").map((c) => c + c).join("") : m, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
export const SET_COLORS = ["#2B5DA8", "#2A9D8F", "#7A4BA8", "#B93268", "#5F8B23", "#0E7C86", "#8A5A3C", "#3949AB"];
export const setColor = (k: number) => SET_COLORS[k % SET_COLORS.length];
